import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { setSignaturePreferences, getSignaturePreferences, setPreferencesDialogVisibility } from '../../reducers/signatures';
import Modal from '../modal';
import FontChoices from './fontChoices';
import { getFullName } from '../../utilities/string';
import { Snackbar } from '../snackbar';

import './signature.css';

class SignatureDialog extends React.Component {
    render() {
        const { preferences, profile, dialogVisible, dialogPostAction, setPreferencesDialogVisibility, setSignaturePreferences } = this.props;
        return (
            <div>
                <Modal open={dialogVisible} onClose={() => setPreferencesDialogVisibility(false)} managedClose size="col-xs-12 col-sm-6 col-sm-offset-3">
                    <div className="signature-edit-modal">
                        <div className="row">
                            <div className="col-xs-12">
                                <FormattedMessage id={'createSignature'} defaultMessage={'Create your signature'} tagName={'h4'} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <FontChoices
                                    onSubmit={values =>
                                        setSignaturePreferences(values, () => {
                                            setPreferencesDialogVisibility(false);
                                            Snackbar.success(
                                                <FormattedMessage id={'signaturePreferencesCreated'} defaultMessage={'Signature preferences stored.'} />
                                            );
                                            if (dialogPostAction) {
                                                dialogPostAction();
                                            }
                                        })
                                    }
                                    cancel={() => setPreferencesDialogVisibility(false)}
                                    initialValues={preferences}
                                    name={getFullName(profile)}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    profile: state.identity.profile,
    preferences: state.signatures.preferences,
    dialogVisible: state.signatures.dialogVisible === true,
    dialogPostAction: state.signatures.dialogPostAction
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setSignaturePreferences: setSignaturePreferences,
            getSignaturePreferences: getSignaturePreferences,
            setPreferencesDialogVisibility: setPreferencesDialogVisibility
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SignatureDialog);



// WEBPACK FOOTER //
// ./src/components/signature/signatureDialog.jsx